import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Host, Input, OnDestroy, OnInit } from "@angular/core";
import { Product } from "@brain/models";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BrainCatalogComponent } from "./catalog";

@Component({
    selector: "brain-catalog-product-group",
    templateUrl: "./product-group.html",
    styleUrls: ["./product-group.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrainCatalogProductsComponent implements OnInit, OnDestroy {

  public products: Product[];

  public get catalogName(): string {
      return this.catalog.name;
  }

  /**
   * items per row ?
   */
  @Input()
  private count: number;

  private destroy$: Subject<boolean> = new Subject();

  constructor(
    @Host() private catalog: BrainCatalogComponent,
    private cdRef: ChangeDetectorRef
  ) { }

  public ngOnInit(): void {

      this.catalog.productsChanged()
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
              this.products = this.catalog.resolveProducts(this.count);
              this.cdRef.markForCheck();
          });
  }

  public ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.complete();
      this.destroy$ = null;
  }
}
